import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserCard } from '../interfaces/user-card.interface';
import { ApiResponse } from '../interfaces/api.interface';

@Injectable({
  providedIn: 'root'
})
export class CompanyUserCardsService {
  // Backend controller lives at company/users/:userId/cards (no /payments
  // segment) - see company-user-cards.controller.ts. The extra /payments/
  // here 404'd every request from this service.
  private baseUrl = '/api/company/users';

  constructor(private http: HttpClient) {}

  getAll(userId: number): Observable<ApiResponse<UserCard[]>> {
    return this.http.get<ApiResponse<UserCard[]>>(`${this.baseUrl}/${userId}/cards`);
  }

  delete(userId: number, cardId: number): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.baseUrl}/${userId}/cards/${cardId}`);
  }
}
